import React from 'react';

export default function BackupCodesPanel({ count, onRegenerate }) {
  const getStatusColor = () => {
    if (count === 0) return 'text-red-600 bg-red-100';
    if (count <= 3) return 'text-yellow-600 bg-yellow-100';
    return 'text-green-600 bg-green-100';
  };

  const getStatusMessage = () => {
    if (count === 0) return 'No backup codes available';
    if (count <= 3) return 'Running low on backup codes';
    return 'Backup codes available';
  };

  return (
    <div className="bg-white rounded-xl shadow-lg p-6">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Backup Codes</h2>

      <div className="text-center mb-6">
        <div className="inline-flex items-center justify-center w-24 h-24 mb-4 rounded-full bg-gray-100">
          <span className="text-4xl font-bold text-gray-900">{count}</span>
        </div>
        <p className={`text-sm font-semibold px-4 py-2 rounded-full inline-block ${getStatusColor()}`}>
          {getStatusMessage()}
        </p>
      </div>

      <div className="bg-blue-50 rounded-lg p-4 mb-6">
        <h3 className="font-semibold text-blue-900 mb-2">About Backup Codes:</h3>
        <ul className="space-y-2 text-blue-800 text-sm">
          <li className="flex items-start">
            <svg className="w-4 h-4 mr-2 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
            </svg>
            <span>Use backup codes if you lose access to your authentication device</span>
          </li>
          <li className="flex items-start">
            <svg className="w-4 h-4 mr-2 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
            </svg>
            <span>Each code can only be used once</span>
          </li>
          <li className="flex items-start">
            <svg className="w-4 h-4 mr-2 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
            </svg>
            <span>Store codes in a secure location</span>
          </li>
        </ul>
      </div>

      {count <= 3 && (
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
          <div className="flex">
            <svg className="w-5 h-5 text-yellow-600 mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
            <div>
              <p className="text-sm font-medium text-yellow-800">
                {count === 0 ? 'No backup codes remaining' : 'Low backup codes'}
              </p>
              <p className="text-sm text-yellow-700 mt-1">
                {count === 0 
                  ? 'Generate new backup codes to ensure account recovery access' :'Consider generating new backup codes soon'
                }
              </p>
            </div>
          </div>
        </div>
      )}

      <button
        onClick={onRegenerate}
        className="w-full bg-indigo-600 text-white py-3 rounded-lg font-semibold hover:bg-indigo-700 flex items-center justify-center"
      >
        <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
        </svg>
        Regenerate Backup Codes
      </button>

      <p className="text-xs text-gray-500 text-center mt-3">
        Regenerating will invalidate all existing backup codes
      </p>
    </div>
  );
}